import { useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import Communications from "@/pages/mlo/Communications";
import CallLog from "@/pages/CallLog";

export default function CommunicationsHub() {
  const [sp, setSp] = useSearchParams();
  const tab = sp.get("tab") === "calls" ? "calls" : "messages";
  return (
    <Tabs value={tab} onValueChange={(v) => setSp(v === "calls" ? { tab: "calls" } : {})}>
      <TabsList className="mb-4" data-testid="communications-tabs">
        <TabsTrigger value="messages" data-testid="tab-messages">Emails, postcards & notes</TabsTrigger>
        <TabsTrigger value="calls" data-testid="tab-ai-calls">AI calls</TabsTrigger>
      </TabsList>
      <TabsContent value="messages"><Communications /></TabsContent>
      <TabsContent value="calls"><CallLog /></TabsContent>
    </Tabs>
  );
}
